var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ui-dialog",
    { ref: "dialog", attrs: { title: "Settings", closable: "" } },
    [
      _c("div", { staticClass: "video-layout" }, [
        _c(
          "div",
          [
            _c("ui-switch", {
              attrs: {
                disabled: _vm.isProcessing || !_vm.isReady,
                label:
                  "Cloud mixing " +
                  (_vm.enableBfcp ? "activated" : "deactivated"),
                tooltip: _vm.bfcpTooltip,
                large: "",
              },
              model: {
                value: _vm.enableBfcp,
                callback: function ($$v) {
                  _vm.enableBfcp = $$v
                },
                expression: "enableBfcp",
              },
            }),
            _vm._v(" "),
            _c(
              "ui-select",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.enableBfcp,
                    expression: "enableBfcp",
                  },
                ],
                staticClass: "select",
                attrs: {
                  disabled: _vm.isProcessing || !_vm.isReady,
                  label: "Layout (used when Content is shared)",
                },
                on: {
                  select: function ($event) {
                    return _vm.renderThumbnail(
                      _vm.videoLayoutMap[_vm.selectedVideoLayout]
                    )
                  },
                },
                model: {
                  value: _vm.selectedVideoLayout,
                  callback: function ($$v) {
                    _vm.selectedVideoLayout = $$v
                  },
                  expression: "selectedVideoLayout",
                },
              },
              _vm._l(_vm.videoLayoutList, function (videoLayout) {
                return _c("ui-select-item", {
                  key: videoLayout.videolayout_id,
                  attrs: {
                    disabled:
                      videoLayout.wfactor !== 1 || videoLayout.hfactor !== 1,
                    label: videoLayout.name,
                    value: videoLayout.videolayout_id,
                  },
                })
              }),
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "thumbnail",
            staticClass: "thumbnail",
            attrs: { hidden: !_vm.enableBfcp },
          },
          [
            _c("div", {
              ref: "content",
              staticClass: "content",
              attrs: { hidden: !_vm.isReady },
            }),
            _vm._v(" "),
            _c("div", {
              ref: "share",
              staticClass: "share",
              attrs: { hidden: !_vm.isReady },
            }),
            _vm._v(" "),
            _c("md-tooltip", [_vm._v(_vm._s(_vm.bfcpTooltip))]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "info" }, [
        _vm._v(
          "Note: When updating Settings, it may take up to 60 seconds before the change is activated. Any change will only apply to new sessions and it will not apply to ongoing sessions or existing recordings."
        ),
      ]),
      _vm._v(" "),
      _c(
        "ui-dialog-footer",
        [
          _c("ui-button", {
            attrs: {
              disabled: _vm.isProcessing || !_vm.isReady,
              primary: "",
              text: "Apply",
              tooltip: "Update video layout settings",
            },
            on: { click: _vm.setVideoLayout },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }